import type { Dispatch, SetStateAction } from 'react';
import Button from '@components/UI/Button';
import Modal from '@components/UI/Modal';
import FormInput from '@components/UI/FormInput';

interface CopyProfileModalProps {
    isOpen: boolean;
    setShowCopyModal: Dispatch<SetStateAction<boolean>>;
    copyName: string;
    setCopyName: Dispatch<SetStateAction<string>>;
    isCopying: boolean;
    profileName: string;
    onConfirm: () => void;
}

const CopyProfileModal = ({
    isOpen,
    setShowCopyModal,
    copyName,
    setCopyName,
    isCopying,
    profileName,
    onConfirm
}: CopyProfileModalProps) => {
    return (
        <Modal
            footer={
                <>
                    <Button
                        variant="secondary"
                        onClick={() => {
                            setShowCopyModal(false);
                            setCopyName('');
                        }}
                    >
                        Cancel
                    </Button>
                    <Button disabled={isCopying} variant="primary" onClick={onConfirm}>
                        {isCopying ? 'Creating...' : 'Create Copy'}
                    </Button>
                </>
            }
            isOpen={isOpen}
            title="Duplicate Trading Profile"
            onClose={() => {
                setShowCopyModal(false);
                setCopyName('');
            }}
        >
            <div className="space-y-4">
                <p className="text-zinc-300">
                    Create a copy of <strong>{profileName}</strong>
                </p>
                <FormInput
                    label="New Profile Name"
                    placeholder="Enter a name for the duplicated profile"
                    value={copyName}
                    onChange={(e) => setCopyName(e.target.value)}
                />
            </div>
        </Modal>
    );
};

export default CopyProfileModal;
